var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustOverviewMenu = function SvgTrustOverviewMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.634 3.951c.323 0 .586.262.586.586v6.244h6.243c.297 0 .542.22.58.505l.006.08c0 3.88-3.145 6.634-7.025 6.634A7.024 7.024 0 0 1 2 10.976C2 7.096 4.755 3.95 8.634 3.95Zm-.585 1.2-.163.018c-2.88.368-4.715 2.827-4.715 5.807a5.854 5.854 0 0 0 5.853 5.853c2.98 0 5.44-1.835 5.807-4.715l.017-.163H8.634a.585.585 0 0 1-.58-.506l-.005-.08V5.152ZM10.976 2A7.024 7.024 0 0 1 18 9.024a.585.585 0 0 1-.585.586h-6.44a.585.585 0 0 1-.585-.586V2.585c0-.323.262-.585.586-.585Zm.585 1.2v5.239H16.8l-.018-.163a5.857 5.857 0 0 0-5.058-5.058l-.163-.018Z",
    fill: "#999"
  })));
};
export default SvgTrustOverviewMenu;